<template>
    <div data-cy="container_dashboard_slider">
        <div class="splide" id="home-dashboard-slide">
            <div class="splide__track">
                <ul class="splide__list" data-cy="list_dashboard_slider_images">
                    <li class="splide__slide"
                        v-for="(dashboard, k) in arrDashboard"
                        :key="k"
                        :data-cy="`card_dashboard_slider_item_${k}`"
                        @click="clickDashboard(dashboard, k)">
                        <img class="w-full rounded-lg" :src="dashboard.imageUrl" :data-cy="`img_dashboard_slider_item_${k}`">
                    </li>
                </ul>
            </div>
        </div>

        <!-- <div>
            <button class="bg-yellow-400 p-2 mr-4" @click="btnPrev()">Prev</button>
            <button class="bg-yellow-400 p-2" @click="btnNext()">Next</button>
        </div> -->
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
// import Util from '@/helper/Utility.js';
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

/**
 * @event onLoaded
 */
export default {
    name: "DashboardSlider",
    props: {
        apiConfig: { type: String, required: true },
    },
    data: function() {
        return {
            arrDashboard: [],
            slider: null,
            currentSliderIndex: 0,
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                this.arrDashboard = data;
                this.setSlider();

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function(dashboard, key) {
            let dashboard_number = `dashboard${key+1}`;
            if (dashboard.type == 'link') {
                this.tracking.event('home_dashboard', 'click_dashboard', dashboard_number+ '|' +dashboard.url, null);
                window.location.href = dashboard.url;

            } else if (dashboard.type == 'campaign') {
                this.tracking.event('home_dashboard', 'click_dashboard', dashboard_number+ '|' +dashboard.id, null);
                this.$router.push('/campaign/' + dashboard.id);

            } else if (dashboard.type == 'cat') {
                this.tracking.event('home_dashboard', 'click_dashboard', dashboard_number+ '|' +dashboard.cat, null);
                this.$router.push('/category/' + dashboard.cat);
            }
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#home-dashboard-slide', {
                    type: 'loop',
                    arrows: false,
                    gap: '1rem',
                    padding: '10%',
                    autoplay: true,
                    interval: 5000,
                }).mount();
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },

        btnNext: function() {
            let next = this.currentSliderIndex + 1;
            this.slider.go(next);
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1;
            this.slider.go(prev);
        },
    },
}
</script>
<style lang="scss">
#home-dashboard-slide{
    .splide__pagination{
        position: relative;
        bottom: -5px;
    }
    .splide__pagination__page{
        height: 7px;
        background: #d9d9d9;
    }
    .splide__pagination__page.is-active{
        width: 16px;
        background: #2140a6;
        border-radius: 4px;
        transform: unset;
    }
}

</style>
